'use strict';

class Trackjs {
    initialize(appInfo, user) {
        const config = require('config/trackjs/' + appInfo.getAppEnv());
        if(user) {
            const u = {
                name : user.getName(),
                id : user.id
            };
            config['userId'] = JSON.stringify(u);
        }
        window._trackJs = config;

        require('trackjs');
    }
}

module.exports = new Trackjs();


// WEBPACK FOOTER //
// ./common/infra/trackjs.js